function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeading3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  className: "heading-3_svg__icon heading-3_svg__flat-color",
  "data-name": "Flat Color",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 20h-1a3 3 0 0 1-3-3 1 1 0 0 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-.75a1 1 0 0 1-.82-1.57L19.1 10H16a1 1 0 0 1 0-2h5a1 1 0 0 1 .82 1.57L20 12.18A3 3 0 0 1 22 15v2a3 3 0 0 1-3 3m-7 0h-2a1 1 0 0 1 0-2v-5H5v5a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2V6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2v5h5V6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2v12a1 1 0 0 1 0 2",
  style: {
    fill: "currentColor"
  }
}));
export default SvgHeading3;